import React from "react";
import ReactDOM from "react-dom/client";
import { Bootstrap } from "./Bootstrap.jsx";
import "./styles.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root not found");
}


ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Bootstrap />
  </React.StrictMode>
);
